import { render, staticRenderFns } from "./fragment-checkbox-group.vue?vue&type=template&id=f27941cc&scoped=true&"
import script from "./fragment-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./fragment-checkbox-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27941cc",
  null
  
)

export default component.exports